import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import { addNotification, clearNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import api from '../../../services/api.services'
import {
  CustomType,
  GetTotalPointsProgress$Request,
  GetTotalPointsProgress$Response,
  GetUserCustomProgress$Request,
  GetUserCustomProgress$Response,
  GetUserDailyDiaryProgress$Request,
  GetUserDailyDiaryProgress$Response,
  GetUserDetailedProgress$Response,
  GoalId,
  UserId,
  UserProfileDto,
} from '../../../services/api.types'
import {
  addCustomEntry,
  addCustomEntryFail,
  addCustomEntrySuccess,
  getCustomProgress,
  getCustomProgressForPoints,
  getCustomProgressSuccess,
  getDailyProgress,
  getDailyProgressSuccess,
  getProgress,
  getProgressSuccess,
  getTotalPointsProgress,
  getTotalPointsProgressSuccess,
  refreshChallengeResults,
  setLastBonusPointsAdded,
} from './ProgressActions'
import { Action } from 'redux-actions'
import { getUserDto } from '../../../common/auth/authSelectors'
import {
  getCurrentCompanyGoal,
  getCurrentGoalActivityList,
  getSingleChallengeWithProgress,
} from '../../Activity/store/ActivityActions'
import { getErrorMsg } from '../../../common/helpers/translations'
import { CustomEntryState } from '../../../components/YumManualEntryForm/YumManualEntryForm'
import { getUserCompanies } from '../../RegisterUser/store/RegisterUserSelectors'
import { store } from '../../../index'
import { IGlobalState } from '../../../Root/store/appReducer'
import { convertDateToTallinnTimeZone } from '../../../common/helpers/date'
import dayjs from '../../../dayjsConfig'
import { CustomTypeCategory } from '../../../services/CustomTypes'
import Bugsnag from '@bugsnag/js'
import { t } from 'ttag'
import { updateLastSync } from '../../../common/auth/authActions'

// Deprecated
function* sagaGetProgress({ payload }: Action<any>) {
  const { startDate, endDate } = payload || {}
  const userDto: UserProfileDto = yield select(getUserDto)
  const userId = userDto.userId

  // Please change Katriito kliinik company progress tab goal from 12k steps a day to 6k steps a day
  const userCompanies = getUserCompanies(store.getState() as any as IGlobalState)
  const isKatriito =
    userCompanies && userCompanies.some(({ companyId }) => companyId === 'b671988d-b6e3-4fac-b737-7b0bdffbaaf8')
  const customStepsGoal = isKatriito ? 6000 : false

  try {
    // @ts-ignore
    const { progressResults }: GetUserDetailedProgress$Response = yield call(
      // @ts-ignore
      api.activity.getUserDetailedProgress,
      {
        userId,
        startDate,
        endDate,
      },
    )

    // TODO: Get progress from here instead.
    /*yield put({
      type: String(getDailyProgress),
      payload: {
        customType: CustomType.STEPS,
        // TODO: It would be more efficient to get the dates originally in the simple date format.
        startDate: dayjs.utc(startDate).locale('en').format('YYYY-MM-DD'),
        endDate: dayjs.utc(endDate).locale('en').format('YYYY-MM-DD'),
      },
    })*/

    yield put({ type: String(getProgressSuccess), payload: { startDate, endDate, progressResults, customStepsGoal } })
  } catch (e: any) {
    console.error('GetProgress failed: ', e)
    /*const getProgressErrorNotification: INotification = {
      type: 'warning',
      content: t`There was a problem within our system while getting progress. Please refresh or contact our support support@yumuuv.com`,
    }
    yield put({ type: String(addNotification), payload: getProgressErrorNotification })*/
  }
}

function* sagaGetCustomProgress({ payload }: Action<GetUserCustomProgress$Request>) {
  // console.log('sagaGetCustomProgress')
  try {
    const { goalId, startDate, endDate, pointsLogicId } = payload
    const { customDiary }: GetUserCustomProgress$Response = yield call(api.activity.getUserCustomProgress, payload)
    yield put({
      type: String(getCustomProgressSuccess),
      payload: { goalId, startDate, endDate, customDiary, pointsLogicId },
    })
  } catch (e: any) {
    console.error('GetCustomProgress failed: ', e)
    /*const getProgressErrorNotification: INotification = {
      type: 'warning',
      content: t`There was a problem within our system while getting progress. Please refresh or contact our support support@yumuuv.com`,
    }
    yield put({ type: String(addNotification), payload: getProgressErrorNotification })*/
  }
}

function* sagaGetDailyProgress({ payload }: Action<GetUserDailyDiaryProgress$Request>) {
  try {
    const { startDate, endDate, customType } = payload
    const { dailyDiary }: GetUserDailyDiaryProgress$Response = yield call(
      api.activity.getUserDailyDiaryProgress,
      payload,
    )
    yield put({ type: String(getDailyProgressSuccess), payload: { startDate, endDate, customType, dailyDiary } })
  } catch (e: any) {
    console.error('GetUserDailyDiaryProgress failed: ', e)
  }
}

function* sagaAddCustomEntry({ payload }: Action<CustomEntryState>) {
  try {
    yield put({ type: String(clearNotification) })
    const {
      amount,
      customType,
      date,
      goalId,

      startDate,
      endDate,
      participating,

      isCollective,
      isActivityIndex,
      manualEntryEnabled,

      pointsLogicId,
      isPoints,
      isMeView,

      isBonus,
      userId,
    } = payload

    // Save to DB.
    // @ts-ignore
    const { message } = yield call(api.activity.customEntry, {
      amount,
      customType,
      date,
      goalId,
      pointsLogicId: pointsLogicId || null,
      userId: isBonus ? userId : null,
    })
    if (message && message === 'The total maximum value for the challenge period has been exceeded.') {
      const notification: INotification = {
        type: 'info',
        content: t`The total maximum value for the challenge period has been exceeded.`,
      }
      yield put({ type: String(addNotification), payload: notification })
    }

    if (isBonus) {
      yield put({ type: String(setLastBonusPointsAdded) })
    }

    yield put({
      type: String(refreshChallengeResults),
      payload: {
        goalId,
        customType,
        startDate,
        endDate,
        participating,
        isCollective,
        isActivityIndex,
        manualEntryEnabled,
        pointsLogicId,
        isPoints,
        isMeView,
        userId,
      },
    })

    yield put({ type: String(addCustomEntrySuccess) })
  } catch (e: any) {
    yield put({ type: String(addCustomEntryFail) })
    console.log('CustomEntry failed: ', e)
    let content = e.message || t`Manual entry failed. Please check your internet connection and try again!`
    if (content === 'Invalid date! You cannot enter data for future dates.') {
      content = t`You cannot enter data for future dates. Check your time zone.`
    }
    const notification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: notification })
    Bugsnag.notify(new Error('CustomEntry error'), function (event) {
      event.context = 'customEntryError'
      event.addMetadata('error', e)
    })
  }
}

export interface RefreshChallengeResultsState {
  customType: CustomType | null
  goalId: GoalId
  endDate: string
  startDate: string
  participating: boolean
  isCollective?: boolean
  isActivityIndex?: boolean
  preventListUpdate?: boolean
  manualEntryEnabled?: boolean
  pointsLogicId: string | null
  pointsLogic?: any[] | null
  isPoints?: boolean
  isMeView?: boolean
  groupSum?: boolean
  token?: string
  oldSplitRankingView?: boolean

  isBonus?: boolean
  userId?: UserId
}

export interface GetCustomProgressForPointsState {
  goalId: GoalId
  endDate: string
  startDate: string
  pointsLogic?: any[] | null
  userId?: UserId
}

function* sagaGetCustomProgressForPoints({ payload }: Action<GetCustomProgressForPointsState>) {
  const { goalId, startDate, endDate, userId } = payload
  let pointsLogic = payload.pointsLogic
  if (pointsLogic && pointsLogic.length) {
    // Remove unknown categories
    pointsLogic = pointsLogic.filter((a) => Object.values(CustomTypeCategory).includes(a.category))
    if (pointsLogic.length > 0) {
      yield all(
        pointsLogic.map((activity) => {
          if (
            [
              CustomTypeCategory.CUSTOM_SIMPLE,
              CustomTypeCategory.CUSTOM_WITH_AMOUNT,
              CustomTypeCategory.BONUS_SIMPLE,
              CustomTypeCategory.BONUS_WITH_AMOUNT,
            ].includes(activity.category)
          ) {
            return put({
              type: String(getCustomProgress),
              payload: {
                goalId,
                customType: activity.unit,
                startDate,
                endDate,
                pointsLogicId: activity.id,
                userId,
              },
            })
          } else {
            return put({
              type: String(getDailyProgress),
              payload: {
                customType: activity.unit,
                startDate,
                endDate,
              },
            })
          }
        }),
      )
    }
  }
}

function* sagaRefreshChallengeResults({ payload }: Action<RefreshChallengeResultsState>) {
  try {
    const {
      customType,
      goalId,
      startDate,
      endDate,
      participating,
      isCollective,
      isActivityIndex,
      preventListUpdate,
      manualEntryEnabled,
      pointsLogicId,
      pointsLogic,
      isPoints,
      isMeView,
      groupSum,
      token,
      oldSplitRankingView,

      isBonus,
      userId,
    } = payload
    // console.log('sagaRefreshChallengeResults', payload)

    if (isPoints) {
      yield put({
        type: String(getCustomProgress),
        payload: {
          goalId,
          customType: CustomType.POINTS,
          startDate,
          endDate,
        },
      })
    }

    if (!token && customType && customType !== CustomType.TOTAL_POINTS) {
      if (customType === CustomType.POINTS) {
        yield put({
          type: String(getCustomProgressForPoints),
          payload: { goalId, startDate, endDate, pointsLogic, userId },
        })
      } else if (customType === CustomType.CUSTOM) {
        yield put({
          type: String(getCustomProgress),
          payload: {
            goalId,
            customType,
            startDate,
            endDate,
            pointsLogicId,
            userId,
          },
        })
      } else if (!token) {
        if (!isActivityIndex || manualEntryEnabled) {
          yield put({
            type: String(getDailyProgress),
            payload: {
              customType,
              startDate,
              endDate,
            },
          })
        }
        if (isActivityIndex) {
          if (manualEntryEnabled) {
            yield put({
              type: String(getDailyProgress),
              payload: {
                customType: CustomType.CALORIES,
                startDate,
                endDate,
              },
            })
            yield put({
              type: String(getDailyProgress),
              payload: {
                customType: CustomType.INTENSIVE_MINUTES,
                startDate,
                endDate,
              },
            })

            // All sync percentages
            yield put({
              type: String(getProgress),
              payload: {
                startDate: convertDateToTallinnTimeZone(dayjs(startDate).toDate()),
                endDate: convertDateToTallinnTimeZone(dayjs(endDate).toDate()),
              },
            })
          } else {
            // Just sync percentages
            yield put({
              type: String(getProgress),
              payload: {
                startDate: convertDateToTallinnTimeZone(dayjs(startDate).toDate()),
                endDate: convertDateToTallinnTimeZone(dayjs(endDate).toDate()),
              },
            })
          }
        }
      }
    }

    if (isMeView || token) {
      // On initial load, ChallengeMe loads this instead.
      if (!preventListUpdate) {
        yield put({
          type: String(getSingleChallengeWithProgress),
          payload: {
            goalId,
            groupSum,
            token,
          },
        })
      }
      // Important! Bump "userDto.lastSync" to trigger leaderboard table refresh.
      yield put({ type: String(updateLastSync) })
    } else {
      // If was not participating, load goal again with list. Or if it's collective challenge.
      if (!participating || isCollective) {
        yield put({
          type: String(getCurrentCompanyGoal),
          payload: {
            id: goalId,
            silentGoalUpdate: true,
            updateList: !preventListUpdate,
            token,
          },
        })
      }
      // If user WAS participating, just refresh the list.
      else if (!preventListUpdate) {
        // This should not be called for "me" view.
        yield put({
          type: String(getCurrentGoalActivityList),
          payload: {
            goalId,
          },
        })
      }

      if (oldSplitRankingView) {
        yield put({
          type: String(getSingleChallengeWithProgress),
          payload: {
            goalId,
            groupSum,
            token,
          },
        })
      }
    }
  } catch (e: any) {
    console.log('RefreshChallengeResults failed: ', e)
    const content = e.message || getErrorMsg('results refresh')
    const notification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: notification })
  }
}

function* sagaGetTotalPointsProgress({ payload }: Action<GetTotalPointsProgress$Request>) {
  console.log('sagaGetTotalPointsProgress')
  try {
    const { goalId } = payload
    const { pointsProgress }: GetTotalPointsProgress$Response = yield call(api.activity.getTotalPointsProgress, payload)
    yield put({
      type: String(getTotalPointsProgressSuccess),
      payload: { goalId, pointsProgress },
    })
  } catch (e: any) {
    console.error('sagaGetTotalPointsProgress failed: ', e)
    /*const getProgressErrorNotification: INotification = {
      type: 'warning',
      content: t`There was a problem within our system while getting progress. Please refresh or contact our support support@yumuuv.com`,
    }
    yield put({ type: String(addNotification), payload: getProgressErrorNotification })*/
  }
}

export function* progressSagas() {
  yield all([
    takeEvery(String(getProgress), sagaGetProgress),
    takeEvery(String(getCustomProgress), sagaGetCustomProgress),
    takeEvery(String(getCustomProgressForPoints), sagaGetCustomProgressForPoints),
    takeEvery(String(getDailyProgress), sagaGetDailyProgress),
    takeEvery(String(addCustomEntry), sagaAddCustomEntry),
    takeEvery(String(refreshChallengeResults), sagaRefreshChallengeResults),
    takeEvery(String(getTotalPointsProgress), sagaGetTotalPointsProgress),
  ])
}
